// extracted by mini-css-extract-plugin
export default {"container":"privacyPolicy_container__KUa7b","title":"privacyPolicy_title__MROki"};